import React from "react";
import "./deviceBlocker.css";

const MESSAGE =
  "This experience is not supported on mobile devices. Please use a laptop or desktop computer to continue.";

export default function DeviceBlocker() {
  return (
    <div className="device-blocker" role="alert" aria-live="polite">
      <p className="device-blocker__text">{MESSAGE}</p>
    </div>
  );
}
